import type { JSX } from 'react';
import React from 'react';

import growthCreditIcon from '../../../images/growth_credit_icon.svg';

function GrowthCreditIcon(): JSX.Element {
  return <img alt={'Growth credit icon'} src={growthCreditIcon} />;
}

export default GrowthCreditIcon;
